function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownItem, Progress, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button, Pagination, PaginationItem, PaginationLink, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText, Row, Col } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Loader, Types } from 'react-loaders';
import 'react-block-ui/style.css';
// import '../../../loaders.min.css';
import './Reset.css';
import { loginStore as store, LoginActions as actions } from './LoginManager';

var logdown = require('logdown');
var console = logdown('rx-login-reset', { prefixColor: '#689f38' });

export var Reset = function (_Component) {
    _inherits(Reset, _Component);

    function Reset(props) {
        _classCallCheck(this, Reset);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            newPassword: '',
            newPasswordConfirm: '',
            verificationCode: '',
            blocking: false,
            confirmed: false,
            username: _this.props.username,
            blockingClass: "",
            blockingMessage: "CAMBIO LA PASSWORD",
            errorMessage: ""

            // this.props.resetActions.subscribe(() => {
            //   this.setState({confirmed: true});
            // });
        };_this.onConfirm = _this.props.onConfirm;

        _this.handleVerificationCodeChange = _this.handleVerificationCodeChange.bind(_this);
        _this.handleNewPasswordChange = _this.handleNewPasswordChange.bind(_this);
        _this.handleNewPasswordConfirmChange = _this.handleNewPasswordConfirmChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.backToLogin = _this.backToLogin.bind(_this);

        return _this;
    }

    Reset.prototype.componentDidMount = function componentDidMount() {
        // console.log(`mount with username: ${this.state.username}`)
    };

    Reset.prototype.handleVerificationCodeChange = function handleVerificationCodeChange(event) {
        this.setState({ verificationCode: event.target.value });
    };

    Reset.prototype.handleNewPasswordChange = function handleNewPasswordChange(event) {
        this.setState({ newPassword: event.target.value });
    };

    Reset.prototype.handleNewPasswordConfirmChange = function handleNewPasswordConfirmChange(event) {
        this.setState({ newPasswordConfirm: event.target.value });
    };

    Reset.prototype.handleSubmit = function handleSubmit(e) {
        var _this2 = this;

        console.log('actions: ' + JSON.stringify(actions));

        console.log('with user: ' + this.props.username);
        this.setState({ blocking: true });
        var cb = function cb(success, failure) {

            if (failure) {

                console.log('failure: ' + failure.code);
                _this2.setState({ blocking: true, blockingMessage: '' + failure.code, blockingColor: '#ff0000', blockingClass: "", errorMessage: failure.code + ':' + failure.message });

                setTimeout(function () {
                    _this2.setState({ blocking: false, blockingMessage: "CAMBIO LA PASSWORD" });
                }, 1000);
            } else {
                _this2.onConfirm(success);
            }
        };

        store.dispatch({ type: actions.RESET,
            verification_code: this.state.verificationCode,
            new_password: this.state.newPassword,
            username: this.props.username,
            cb: cb
        });
    };

    Reset.prototype.backToLogin = function backToLogin(e) {
        console.log('try to back to login');
        this.props.loginActions.dispatch({ type: 'RESET_CONFIRM' });
    };

    Reset.prototype.render = function render() {
        var _this3 = this;

        return React.createElement(
            Modal,
            this.props,
            React.createElement(
                ModalHeader,
                { toggle: this.props.toggleModal, style: { width: '100%' } },
                React.createElement(
                    'small',
                    null,
                    '\xC8 stato richiesto un reset della password'
                )
            ),
            React.createElement(
                ModalBody,
                null,
                !this.state.confirmed ? React.createElement(
                    BlockUi,
                    { tag: 'div', blocking: this.state.blocking, message: this.state.blockingMessage, loader: React.createElement(Loader, { active: true, type: 'line-scale-pulse-out', color: '#4dbd74' }) },
                    React.createElement(
                        'div',
                        { className: 'card-group mb-0' },
                        React.createElement(
                            'div',
                            { className: 'card p-4' },
                            React.createElement(
                                'div',
                                { className: 'card-block' },
                                React.createElement(
                                    AvForm,
                                    null,
                                    React.createElement(
                                        AvGroup,
                                        null,
                                        React.createElement(
                                            'div',
                                            { className: 'input-group mb-3' },
                                            React.createElement(
                                                'span',
                                                { className: 'input-group-addon' },
                                                React.createElement('i', { className: 'icon-key' })
                                            ),
                                            React.createElement(AvInput, { name: 'verificationCode', id: 'verificationCode', type: 'text', className: 'form-control', placeholder: 'Codice di Verifica', value: this.state.verificationCode, onChange: this.handleVerificationCodeChange, required: true })
                                        ),
                                        React.createElement(
                                            AvFeedback,
                                            null,
                                            'Codice di Verifica Obbligatorio'
                                        )
                                    ),
                                    React.createElement(
                                        AvGroup,
                                        null,
                                        React.createElement(
                                            'div',
                                            { className: 'input-group mb-3' },
                                            React.createElement(
                                                'span',
                                                { className: 'input-group-addon' },
                                                React.createElement('i', { className: 'icon-lock' })
                                            ),
                                            React.createElement(AvInput, { name: 'newPassword', id: 'newPassword', type: 'password', className: 'form-control', placeholder: 'Nuova Password', value: this.state.newPassword, onChange: this.handleNewPasswordChange, required: true })
                                        ),
                                        React.createElement(
                                            AvFeedback,
                                            null,
                                            'Password Obbligatoria'
                                        )
                                    ),
                                    React.createElement(
                                        AvGroup,
                                        null,
                                        React.createElement(
                                            'div',
                                            { className: 'input-group mb-4' },
                                            React.createElement(
                                                'span',
                                                { className: 'input-group-addon' },
                                                React.createElement('i', { className: 'icon-lock' })
                                            ),
                                            React.createElement(AvInput, { name: 'newPasswordConfirm', id: 'newPasswordConfirm', type: 'password', className: 'form-control', placeholder: 'Conferma Nuova Password', value: this.state.newPasswordConfirm, onChange: this.handleNewPasswordConfirmChange, validate: { match: { value: 'newPassword' } } })
                                        ),
                                        React.createElement(
                                            AvFeedback,
                                            null,
                                            'la Password non corrisponde'
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'row' },
                                        React.createElement(
                                            'div',
                                            { className: 'col-12' },
                                            React.createElement(
                                                'button',
                                                { type: 'button', className: 'btn btn-success btn-block px-4', onClick: function onClick(e) {
                                                        return _this3.handleSubmit(e);
                                                    } },
                                                'Salva la nuova password'
                                            ),
                                            React.createElement(
                                                'div',
                                                { style: { color: 'red' } },
                                                this.state.errorMessage
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'card card-inverse card-success py-5 d-md-down-none', style: { width: 44 + '%' } },
                            React.createElement(
                                'div',
                                { className: 'card-block text-center' },
                                React.createElement(
                                    'div',
                                    null,
                                    React.createElement(
                                        'h2',
                                        null,
                                        'Reset Password'
                                    ),
                                    React.createElement(
                                        'p',
                                        null,
                                        'Inserire la nuova password e il codice di verifica inviato via email'
                                    )
                                )
                            )
                        )
                    )
                ) : React.createElement(
                    'div',
                    { className: 'card card-inverse py-5 d-md-down-none', style: { width: 100 + '%' } },
                    React.createElement(
                        'div',
                        { className: 'card-block text-center' },
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'h2',
                                null,
                                'Password Resettata'
                            ),
                            React.createElement(
                                Button,
                                { outline: true, color: 'success', onClick: function onClick(e) {
                                        return _this3.backToLogin(e);
                                    } },
                                'Ritorna alla login'
                            ),
                            ' '
                        )
                    )
                )
            )
        );
    };

    return Reset;
}(Component);